// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3QfmL","actions":"GroupTable_actions__3Slq6","deleteModalFooter":"GroupTable_deleteModalFooter__r4zKb"};